import React from 'react'
import { findDOMNode } from 'react-dom'

export default function listenForOutsideClicks(
    listening: boolean,
    ref: React.MutableRefObject<any>,
    callback: () => void
) {
    return () => {
        if (!ref.current || !listening) return;
        [`click`, `touchstart`].forEach((type) => {
            function eventType(evt) {
                const cur = ref.current;
                const element = findDOMNode(cur)
                const node = evt.target as Node;
                if (!element?.contains(node)) {                    
                    callback()
                    document.removeEventListener(type, eventType, false)
                }
            }
            document.addEventListener(type, eventType, false)
        });
    };
}
